
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const PricingTable = () => {
    return (
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {/* Free Tier */}
            <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm hover:shadow-md transition-all">
                <h3 className="font-bold text-xl text-gray-900 mb-2">Free</h3>
                <div className="flex items-baseline gap-1 mb-6">
                    <span className="text-4xl font-bold text-gray-900">$0</span>
                    <span className="text-gray-500">forever</span>
                </div>
                <ul className="space-y-4 mb-8">
                    <li className="flex items-center gap-3 text-sm text-gray-600">
                        <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
                        1 active contest
                    </li>
                    <li className="flex items-center gap-3 text-sm text-gray-600">
                        <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
                        500 entries max
                    </li>
                    <li className="flex items-center gap-3 text-sm text-gray-600">
                        <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
                        Watermark included
                    </li>
                    <li className="flex items-center gap-3 text-sm text-gray-600">
                        <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
                        CSV export (post-contest)
                    </li>
                    <li className="flex items-center gap-3 text-sm text-gray-600">
                        <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
                        Embed on your site
                    </li>
                </ul>
                <Button asChild variant="outline" className="w-full rounded-full border-gray-300 hover:bg-gray-50">
                    <Link to="/admin/contests/new">Start Free</Link>
                </Button>
            </div>

            {/* Starter Tier */}
            <div className="bg-white rounded-2xl p-8 border-2 border-primary shadow-xl relative transform md:-translate-y-4">
                <div className="absolute top-0 right-0 bg-primary text-white text-xs font-bold px-3 py-1 rounded-bl-lg rounded-tr-lg">
                    POPULAR
                </div>
                <h3 className="font-bold text-xl text-primary mb-2">Starter</h3>
                <div className="flex items-baseline gap-1 mb-2">
                    <span className="text-4xl font-bold text-gray-900">$9</span>
                    <span className="text-gray-500">/mo</span>
                </div>
                <p className="text-xs text-green-600 font-medium mb-6 bg-green-50 inline-block px-2 py-1 rounded">First 3 months free</p>

                <ul className="space-y-4 mb-8">
                    <li className="flex items-center gap-3 text-sm text-gray-600">
                        <Check className="w-5 h-5 text-primary flex-shrink-0" />
                        <strong>3 active contests</strong>
                    </li>
                    <li className="flex items-center gap-3 text-sm text-gray-600">
                        <Check className="w-5 h-5 text-primary flex-shrink-0" />
                        <strong>Unlimited entries</strong>
                    </li>
                    <li className="flex items-center gap-3 text-sm text-gray-600">
                        <Check className="w-5 h-5 text-primary flex-shrink-0" />
                        Analytics
                    </li>
                    <li className="flex items-center gap-3 text-sm text-gray-600">
                        <Check className="w-5 h-5 text-primary flex-shrink-0" />
                        Branding control
                    </li>
                    <li className="flex items-center gap-3 text-sm text-gray-600">
                        <Check className="w-5 h-5 text-primary flex-shrink-0" />
                        Additional data fields
                    </li>
                    <li className="flex items-center gap-3 text-sm text-gray-600">
                        <Check className="w-5 h-5 text-primary flex-shrink-0" />
                        Abuse & fraud prevention
                    </li>
                    <li className="flex items-center gap-3 text-sm text-gray-600">
                        <Check className="w-5 h-5 text-primary flex-shrink-0" />
                        Subtle RaffleKit branding
                    </li>
                </ul>
                <Button asChild className="w-full rounded-full shadow-lg hover:shadow-glow font-bold">
                    <Link to="/admin/contests/new">Get Started</Link>
                </Button>
                <p style={{
                    fontSize: 11,
                    color: "#94a3b8",
                    textAlign: "center",
                    marginTop: 6,
                    lineHeight: 1.4,
                }}>
                    No charge until after your first 3 months.
                </p>
            </div>

            {/* Growth Tier */}
            <div className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm hover:shadow-md transition-all">
                <h3 className="font-bold text-xl text-gray-900 mb-2">Growth</h3>
                <div className="flex items-baseline gap-1 mb-6">
                    <span className="text-4xl font-bold text-gray-900">$29</span>
                    <span className="text-gray-500">/mo</span>
                </div>
                <ul className="space-y-4 mb-8">
                    <li className="flex items-center gap-3 text-sm text-gray-600">
                        <Check className="w-5 h-5 text-blue-500 flex-shrink-0" />
                        Everything in Starter
                    </li>
                    <li className="flex items-center gap-3 text-sm text-gray-600">
                        <Check className="w-5 h-5 text-blue-500 flex-shrink-0" />
                        Unlimited contests
                    </li>
                    <li className="flex items-center gap-3 text-sm text-gray-600">
                        <Check className="w-5 h-5 text-blue-500 flex-shrink-0" />
                        Remove RaffleKit branding
                    </li>
                    <li className="flex items-center gap-3 text-sm text-gray-600">
                        <Check className="w-5 h-5 text-blue-500 flex-shrink-0" />
                        Custom fields
                    </li>
                    <li className="flex items-center gap-3 text-sm text-gray-600">
                        <Check className="w-5 h-5 text-blue-500 flex-shrink-0" />
                        <span className="flex items-center gap-2">
                            Integrations
                            <span className="text-xs font-semibold px-2 py-0.5 rounded-full bg-blue-100 text-blue-700">
                                Coming Soon
                            </span>
                        </span>
                    </li>
                    <li className="flex items-center gap-3 text-sm text-gray-600">
                        <Check className="w-5 h-5 text-blue-500 flex-shrink-0" />
                        Priority support
                    </li>
                </ul>
                <Button asChild variant="outline" className="w-full rounded-full border-gray-300 hover:bg-gray-50">
                    <Link to="/admin?mode=signup">Get Started</Link>
                </Button>
            </div>
        </div>
    );
};
